
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmAbandon as ObiAlarmAbandonElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-abandon.js';
 
 
 

 
 export const ObiAlarmAbandon = createComponent({
   react: React,
   tagName: 'obi-alarm-abandon',
   elementClass: ObiAlarmAbandonElement,
   events: {
     
   }
  });
 
 